import { Icon } from '@material-ui/core';

import { ButtonIcon, Tooltip } from '~/componentsV2';

const PAGE_NAME = 'PriorityMenus';

export default function PriorityMenus({ menuItems, devCenterRouter, isMobileView }) {
  return menuItems.map(menuConfig => (
    <Tooltip
      placement="top"
      disabled={!!isMobileView}
      title={menuConfig.title}
      key={menuConfig.title}
    >
      <ButtonIcon
        testId={`${PAGE_NAME}_item_${menuConfig.title}`}
        size="small"
        type="tertiaryBg"
        onClick={() => {
          menuConfig.onClick?.();

          if (menuConfig.to) {
            devCenterRouter.push(menuConfig.to);
          }
        }}
      >
        <Icon>{menuConfig.icon}</Icon>
      </ButtonIcon>
    </Tooltip>
  ));
}
